import styled from "styled-components";
const StyledCoursePage = styled.div`
  .first-course {
    font-size: 20px;
    font-weight: 500;
    text-align: left;
    margin-bottom: 1rem; /* 1rem is equivalent to 16px by default */
  }
  .searchbar-style {
    color: #636980;
    border: 1px solid #e2e2e8;
    width: 210px;
    border-radius: 24px;
    font-size: 14px;
    font-weight: 400;
  }
  .reorder-button {
    width: 170px;
    height: 34px;
    padding: 6.5px 55px 6.5px 56px;
    border-radius: 8px;
    border: 1px solid #1f243b !important;
    margin-right: 20px;
    color: #1f243b !important;
    background-color: transparent !important;
    cursor: pointer;
  }
  .reorder-button:hover,
  .reorder-button:focus,
  .reorder-button:active {
    color: #1f243b !important;
    background-color: transparent !important;
    outline: none !important;
  }

  .create-field-button {
    width: 170px;
    height: 34px;
    padding: 6.5px 29px 6.5px 30px;
    border-radius: 8px;
    border: #c2fae5;
    background-color: #c2fae5;
    cursor: pointer;
    transition: none !important;
  }

  .create-field-button:hover,
  .create-field-button:active {
    background-color: #c2fae5 !important;
    border: #c2fae5 !important;
    color: black !important;
  }

  /* Apply the styles to all table rows */
  .table-row {
    font-size: 14px;
    font-weight: 400;
    color: #636980;
  }

  .custom-table {
    border: 1px solid #e2e2e8;
    border-radius: 8px;
  }

  .custom-table td {
    font-size: 14px;
    font-weight: 400;
    color: #636980;
  }

  .table-row-white {
    background-color: #ffffff;
  }

  .table-row-gray {
    background-color: #f5f5f5;
  }
  /* Hide the action icons by default */
  .action-icons {
    visibility: hidden;
    display: flex;
    gap: 30px;
    align-items: center;
    margin-left: 20px;
  }

  /* Show action icons only when the row is hovered */
  .ant-table-row:hover .action-icons {
    visibility: visible;
  }

  .edit-icon {
    cursor: pointer;
    width: 25px;
    height: 25px;
  }

  .edit-icon:hover {
  }

  .delete-icon {
    cursor: pointer;
    width: 25px;
    height: 25px;
  }

  .delete-icon:hover {
  }
  // .footer-button {
  //   display: flex;
  //   margin-left: 100px;
  //   gap: 20px;
  }
  // .cancel-button {
  //   width: 130px;
  //   height: 34px;
  //   padding: 6.5px 38.5px 6.5px 39.5px;
  //   border-radius: 8px;
  //   border: 1px solid #1f243b;
  //   font-weight: 500;
  //   text-align: center;
  // }

  .custom-field {
    cursor: pointer;
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    color: #636980;
  }

  .editing-creating-text {
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    color: #1f243b;
  }

  .name-text,
  .mandatory-text,
  .visible1-text,
  .type-text,
  .visible-report-text {
    font-size: 14px;
    font-weight: 500;
    color: #636980;
  }

  .button-style {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 80%;
    margin-left: 271px;
    background-color: white;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding: 20px;
    padding-top: 20px;
    box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.2);
  }

  .cancel-button1 {
    width: 130px;
    height: 34px;
    border: 1px solid #1f243b;
    border-radius: 8px;
    transition: none !important;
  }

  .cancel-button1:hover,
  .cancel-button1:active {
    border: 1px solid #1f243b !important;
    color: #1f243b !important;
  }

  .save-create-button {
    background-color: #c2fae5;
    width: 130px;
    height: 34px;
    border-radius: 8px;
    color: black;
    transition: none !important;
  }

  .save-create-button:hover,
  .save-create-button:active {
    background-color: #c2fae5 !important;
    color: black !important;
  }

  .dropdown-options-block {
    margin-top: 8px;
    margin-bottom: 24px;
  }

  .dropdown-options-input-row {
    display: flex;
    gap: 8px;
    margin-top: 8px;
    margin-bottom: 12px;
    max-width: 480px;
  }

  .dropdown-options-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    border: 1px solid #e2e2e8;
    border-radius: 8px;
    padding: 14px;
    background-color: #ffffff;
  }

  .dropdown-options-empty {
    font-size: 13px;
    color: #9e9e9e;
  }

  .dropdown-option-tag {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 6px 12px;
    border-radius: 6px;
    background-color: #f0f1f3;
    color: #1f243b;
    font-size: 14px;
  }

  .dropdown-option-tag .anticon {
    cursor: pointer;
    color: #636980;
    font-size: 12px;
  }
`;
export default StyledCoursePage;
